/** @format */

import { baseURL } from "./config";

/**
 * Normalize an image URL — strip any existing host and rebuild with the frontend's baseURL.
 * This ensures images always load from the correct server, regardless of what the backend returns.
 *
 * @param {string} path - Image path or full URL from the backend
 * @param {"thumb"|"medium"|null} size - Optional size variant (WebP)
 * @returns {string} Absolute URL using the frontend's baseURL
 */
export const getImageUrl = (path, size = null) => {
	if (!path) return "";

	// Strip any existing protocol + host prefix to get relative path
	const relativePath = path.replace(/^https?:\/\/[^/]+\//, "");
	if (!relativePath) return "";

	// If a size variant is requested and the path is a storage image, serve the WebP variant
	if (size && (size === "thumb" || size === "medium") && relativePath.startsWith("storage/")) {
		const filename = relativePath.split("/").pop();
		const nameWithoutExt = filename.replace(/\.[^.]+$/, "");
		const webpPath = `storage/${size}/${nameWithoutExt}.webp`;
		return `${baseURL}${webpPath}`;
	}

	return `${baseURL}${relativePath}`;
};
